import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

/** API0310 パスワード変更 リクエストインターフェース */
export type passwordChangeRequest = {
  /** 現在のパスワード */
  nowPassword: string;
  /** 新しいパスワード */
  newPassword: string;
  /** 新しいパスワード確認 */
  newPasswordConfirm: string;
};

/**
 * API0310 パスワード変更
 * @param req
 * @returns
 */
export const postPassword = async (req: passwordChangeRequest): Promise<AxiosResponse> => {
  return await authRequest.post("/v1/user/password/change", req);
};
